import React from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import {
  Row,
  Col
} from 'reactstrap'
import ShopProducts from '../../components/Lists/ShopProducts'

// core components

class ShopProductsContainer extends React.Component {
  render () {
    console.log('ShopProductsContainer')
    return (
      <>
        <div className='content'>
          <Row>
            <Col md='12'>
              <ShopProducts {...this.props} />
            </Col>
          </Row>
        </div>
      </>
    )
  }
}

export default withFirebase(ShopProductsContainer)
